<div mat-dialog-content>Est-ce-que vous voulez supprimer cette évenement?</div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" color="primary">Oui</button>
  <button mat-raised-button [mat-dialog-close]="false" color="warn">Retour</button>
</div>